export enum CampusFirstLevelPage {
  ADMIN = 'admin',
  CHANCENCAMPUS = 'chancencampus',
  PRIVACY = 'privacy',
  IMPRESS = 'impress',
  TEACHER_DASHBOARD = 'teacher-dashboard',
  WORK_TRACKING = 'work-tracking',
}

export enum CampusSecondLevelPage {
  // Campus
  EDITORIAL = 'editorial',
  STUDENT = 'student',
  LOUNGE = 'lounge',
  LOUNGE_EXTERNAL = 'lounge-external',

  // Admin
  SCOPES = 'scopes',
  GROUPS = 'groups',
  COURSES = 'courses',
  CHILDREN_STATISTICS = 'children-statistics',
  STATISTICS = 'statistics',
  PRESENCE = 'presence',
  NOTIFICATIONS = 'notifications',
  LEKO_ABSENCE = 'leko-absence',
  BLANKO_ACCOUNTS = 'blanko-accounts',
  EVENTS = 'events',

  // Teacher Dashboard
  HEFTE = 'hefte',
  TEACHER_DASHBOARD_EMPLOYEE = 'employee',
  STUDENT_OVERVIEW = 'student-overview',
  EMPLOYEE_OVERVIEW = 'employee-overview',
}

export enum CampusThirdLevelPage {
  // Editorial
  LESSONS = 'lessons',
  EXCERCISES = 'exercises',
  LEVUMI_GERMAN = 'levumi-german',
  LEVUMI_MATH = 'levumi-math',
  LEVUMI_NUMBER_DICTATION = 'levumi-number-dictation',
  DIAGNOSTICS = 'diagnostics',
  CUMULATIVE_DIAGNOSTICS = 'cumulative-diagnostics',
  ANSWERS = 'answers',
  LOUNGE = 'lounge',
  LOUNGE_EXTERNAL = 'lounge-external',

  // Student
  DASHBOARD = 'dashboard',
  ALL_LESSONS = 'lessons',
  ALL_LESSONS_CHANCENKURVE = 'lessons-chancenkurve',
  YOUR_LESSONS = 'your-lessons',
  PLAY = 'play',
  CHOOSE_DIGITAL_COURSES = 'choose-digital-courses',
  ALL_NOTIFICATIONS = 'all-notifications',
  EXPORT = 'export',
}

// TODO: Will be removed with an Router update. Its a static class so the enums get resolved
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CampusRoutes {
  static landing = `/`;
  static privacy = `/${CampusFirstLevelPage.PRIVACY}`;
  static impress = `/${CampusFirstLevelPage.IMPRESS}`;

  // Work Tracking
  static workTracking = `/${CampusFirstLevelPage.WORK_TRACKING}`;

  // Student
  static dashboard = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.DASHBOARD}`;
  static allLessons = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.ALL_LESSONS}`;
  static allLessonsChancenkurve = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.ALL_LESSONS_CHANCENKURVE}`;
  static yourLessons = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.YOUR_LESSONS}`;
  static play = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.PLAY}`;
  static chooseDigitalCourses = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.CHOOSE_DIGITAL_COURSES}`;
  static allNotifications = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.ALL_NOTIFICATIONS}`;

  // Editorial
  static lessons = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.LESSONS}`;
  static excercises = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.EXCERCISES}`;
  static editorialLounge = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.LOUNGE}`;
  static editorialLoungeExternal = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.LOUNGE_EXTERNAL}`;
  static levumiGerman = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.LEVUMI_GERMAN}`;
  static levumiMath = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.LEVUMI_MATH}`;
  static levumiNumberDictation = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.LEVUMI_NUMBER_DICTATION}`;
  static diagnostics = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.DIAGNOSTICS}`;
  static export = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.EXPORT}`;
  static answers = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.ANSWERS}`;
  static cumulativeDiagnostics = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.EDITORIAL}/${CampusThirdLevelPage.CUMULATIVE_DIAGNOSTICS}`;

  // Teacher Dashboard
  static teacherDashboardStudentList = `/${CampusFirstLevelPage.TEACHER_DASHBOARD}`;
  static teacherDashboardStudent = `/${CampusFirstLevelPage.TEACHER_DASHBOARD}/`;
  static teacherDashboardHefte = `/${CampusFirstLevelPage.TEACHER_DASHBOARD}/${CampusSecondLevelPage.HEFTE}`;
  static teacherDashboardEmployeeList = `/${CampusFirstLevelPage.TEACHER_DASHBOARD}/${CampusSecondLevelPage.TEACHER_DASHBOARD_EMPLOYEE}`;
  static teacherDashboardStudentOverview = `/${CampusFirstLevelPage.TEACHER_DASHBOARD}/${CampusSecondLevelPage.STUDENT_OVERVIEW}`;
  static teacherDashboardEmployeeOverview = `/${CampusFirstLevelPage.TEACHER_DASHBOARD}/${CampusSecondLevelPage.EMPLOYEE_OVERVIEW}`;

  // Admin
  static scopes = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.SCOPES}`;
  static groups = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.GROUPS}`;
  static childrenStatistics = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.CHILDREN_STATISTICS}`;
  static statistics = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.STATISTICS}`;
  static presence = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.PRESENCE}`;
  static notifications = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.NOTIFICATIONS}`;
  static lekoAbsence = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.LEKO_ABSENCE}`;
  static blankoAccounts = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.BLANKO_ACCOUNTS}`;
  static eventAdmin = `/${CampusFirstLevelPage.ADMIN}/${CampusSecondLevelPage.EVENTS}`;

  // Lounge
  static lounge = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.LOUNGE}`;
  static loungeExternal = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.LOUNGE_EXTERNAL}`;
}
